(ns nosco.polyfills
  (:require
   ["scroll-into-view-if-needed" :as scroll-into-view*]))

;; Polyfills the scrollMode: if-needed option for scrollIntoView
(def scroll-into-view scroll-into-view*)

(when (and (nil? js/window.crypto) js/window.msCrypto)
  (set! (.-crypto js/window) js/window.msCrypto))


(defn IE11? []
  (let [ua (-> js/window
               .-navigator
               .-userAgent)]
    (re-find #"Trident/|MSIE" ua)))
